import { useEffect } from 'react'
import { Box } from '@material-ui/core'

import { SelectedLayer } from './SelectedLayer'
import { Draggable } from 'react-beautiful-dnd'

import { useMapEngine } from '../shared'
import { MAP_ID } from '../../utils/apiHelper'
import { LAYER_KIND } from '../../utils/configQueries'

import { useGlobalContext } from '../../state'
import { useStyles } from './styles'

export const SelectedLayers = () => {
  const classes = useStyles()

  const [engine] = useMapEngine(MAP_ID)
  const {
    state: { layers }
  } = useGlobalContext()

  const layersData = layers
    .filter(({ metadata }) => metadata)
    .filter(({ kind }) => kind === LAYER_KIND.INDICATOR)
    .map(
      ({
        id,
        kind,
        isVisible,
        includeName,
        steps,
        metadata: {
          indicator_name: name,
          unit: description,
          indicator_id: indicatorId
        },
        dimensions,
        membersValues,
        opacity,
        idPaint,
        includeValue,
        isCountry,
        layerType
      }) => ({
        id,
        kind,
        isVisible,
        includeName,
        name,
        steps,
        dimensions,
        params: dimensions
          .map(({ name: dimensionName, members }) => {
            const values = Object.values(membersValues)
            const value = members.filter(({ id }) => values.includes(id))[0]
            return {
              dimensionName,
              value: value?.name
            }
          })
          .filter(({ value }) => value),
        description,
        clasifications: steps
          .slice(2)
          .filter((_, idx) => idx % 2 === 0)
          .map((color, idx) => ({
            color,
            from: steps[idx * 2 + 1] + 1,
            to: steps[idx * 2 + 3]
          })),
        indicatorId,
        opacity,
        idPaint,
        includeValue,
        membersValues,
        isCountry,
        layerType
      })
    )

  useEffect(() => {
    if (engine) {
      const isVisibleLabelsCountry =
        layers.length &&
        layers.some(
          ({ isVisible, includeName, isCountry }) =>
            isVisible && includeName && isCountry
        )
      const isVisibleLabelsCity =
        layers.length &&
        layers.some(
          ({ isVisible, includeName, isCountry }) =>
            isVisible && includeName && !isCountry
        )

      engine.setLayoutProperty(
        'labelsData',
        'visibility',
        isVisibleLabelsCity ? 'visible' : 'none'
      )
      engine.setLayoutProperty(
        'countriesLabels',
        'visibility',
        isVisibleLabelsCountry ? 'visible' : 'none'
      )

      // labelsData layers above all}
      if (isVisibleLabelsCity) engine.moveLayer('labelsData')
      if (isVisibleLabelsCountry) engine.moveLayer('countriesLabels')
    }
  }, [engine, layers])

  return (
    <Box className={classes.containerAccordion}>
      {layersData?.map((layer, index) => (
        <Box key={layer.id}>
          <Draggable draggableId={layer.id} index={index}>
            {(draggableProvided) => (
              <Box
                {...draggableProvided.draggableProps}
                ref={draggableProvided.innerRef}
                className="layer-item"
              >
                <SelectedLayer layer={layer} dragProvided={draggableProvided} />
              </Box>
            )}
          </Draggable>
        </Box>
      ))}
    </Box>
  )
}
